"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrintableAscii = exports.isCircularRedirects = exports.isValidLongUrl = exports.isValidTags = exports.isValidTag = exports.isValidShortUrl = exports.isValidUrl = exports.isHttps = exports.isBlacklisted = exports.isWhitelisted = exports.URL_OPTS = exports.MAX_TAG_LENGTH = exports.TAG_STRING_REGEX = exports.TAG_KEY_REGEX = exports.SHORT_URL_REGEX = exports.WHITELIST = void 0;
var validator_1 = __importDefault(require("validator"));
var url_1 = require("url");
var blacklist_1 = __importDefault(require("../../server/resources/blacklist"));
var constants_1 = require("../constants");
exports.WHITELIST = [new RegExp('^http://localhost:4566')];
exports.SHORT_URL_REGEX = /^[a-z0-9-]+$/;
exports.TAG_KEY_REGEX = /^[a-z0-9-_]+$/;
exports.TAG_STRING_REGEX = /^[A-Za-z0-9-_]+$/;
exports.MAX_TAG_LENGTH = 25;
exports.URL_OPTS = {
    protocols: ['https'],
    require_tld: true,
    require_protocol: true,
    require_host: true,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    disallow_auth: false,
};
// Checks if url is whitelisted.
function isWhitelisted(url) {
    return exports.WHITELIST.some(function (regexp) { return url.match(regexp); });
}
exports.isWhitelisted = isWhitelisted;
// Checks if url is blacklisted.
function isBlacklisted(url) {
    return blacklist_1.default.some(function (bl) { return url.includes(bl); });
}
exports.isBlacklisted = isBlacklisted;
// Tests if a URL string begins with https://.
function isHttps(url, useWhitelist) {
    if (useWhitelist === void 0) { useWhitelist = false; }
    if (useWhitelist && isWhitelisted(url))
        return true;
    return /^https:\/\//.test(url);
}
exports.isHttps = isHttps;
// Check if a URL string is valid.
function isValidUrl(url, useWhitelist) {
    if (useWhitelist === void 0) { useWhitelist = false; }
    if (useWhitelist && isWhitelisted(url))
        return true;
    return validator_1.default.isURL(url, exports.URL_OPTS);
}
exports.isValidUrl = isValidUrl;
// Tests if a short link consists of alphanumeric and hyphen characters.
function isValidShortUrl(url, allowBlank) {
    if (allowBlank === void 0) { allowBlank = false; }
    return allowBlank ? /^[a-z0-9-]*$/.test(url) : exports.SHORT_URL_REGEX.test(url);
}
exports.isValidShortUrl = isValidShortUrl;
// Tests if a tag is valid.
function isValidTag(tag, allowBlank) {
    if (allowBlank === void 0) { allowBlank = false; }
    return ((allowBlank && tag === '') ||
        (exports.TAG_STRING_REGEX.test(tag) && tag.length <= exports.MAX_TAG_LENGTH));
}
exports.isValidTag = isValidTag;
// Tests if a set of tags for a link is valid.
function isValidTags(tags) {
    return (tags.every(function (tag) { return isValidTag(tag); }) &&
        tags.length <= constants_1.MAX_NUM_TAGS_PER_LINK &&
        new Set(tags).size === tags.length);
}
exports.isValidTags = isValidTags;
// Tests the validity of a long url. Will return true if blank.
function isValidLongUrl(url, allowBlank, useWhitelist) {
    if (allowBlank === void 0) { allowBlank = false; }
    if (useWhitelist === void 0) { useWhitelist = false; }
    return (allowBlank && !url) || isValidUrl("https://" + url, useWhitelist);
}
exports.isValidLongUrl = isValidLongUrl;
// Checks if go short url redirects to go domain.
function isCircularRedirects(url, hostname) {
    return Boolean(hostname) && url_1.parse(url).hostname === hostname;
}
exports.isCircularRedirects = isCircularRedirects;
function isPrintableAscii(string) {
    // Only accepts characters from 0x20 to 0x7F
    return /^[\x20-\x7F]*$/.test(string);
}
exports.isPrintableAscii = isPrintableAscii;
